<div class="list-container">
  <ion-row class="input-container">
    <ion-col>
      <ion-item>
        <ion-input
          placeholder="Filter Assets"
          [ngModel]="assetFilter"
          (ngModelChange)="setAssetFilter($event)"
          (ionFocus)="selectText($event)"
          [clearInput]="true"
          />
        </ion-item>
      </ion-col>
      @if (showChangedCheckbox) {
        <ion-col sizeXl="5" sizeLg="6">
          <ion-item class="change-checkbox-container">
            <ion-checkbox
              id="changedCheckbox"
              [(ngModel)]="onlyShowChanged"
              (ionChange)="setChangedFilter($event.detail.checked)"
            ></ion-checkbox>
            <ion-label>Nur Geänderte</ion-label>
          </ion-item>
        </ion-col>
      }
      @if (showRefreshButton) {
        <ion-col sizeXl="1" sizeLg="1" class="refresh-button-container">
          <button
            mat-icon-button
            matTooltip="Liste aktualisieren"
            [matTooltipShowDelay]="200"
            (click)="emitRefreshAction()"
            >
            <ion-icon name="refresh"> </ion-icon>
          </button>
        </ion-col>
      }
    </ion-row>
    @if (filteredElements.length > 0 && !isLoading) {
      <cdk-virtual-scroll-viewport
        itemSize="32"
        class="scroll-container"
        minBufferPx="320"
        maxBufferPx="640"
        >
        <sis-sismap-sidepane-asset-list-item
          class="scroll-element"
          [element]="item.element"
          (click)="clickElement(item)"
          (buttonClicked)="emitActionButtonClick($event, item)"
          (itemDraggedToMap)="emitItemDraggedToMap($event)"
          [selected]="item.element.guid === selectedElement?.guid"
          [draggable]="enableDragging"
          [item]="item"
          [actionButtons]="actionButtons"
          *cdkVirtualFor="let item of filteredElements"
          >
        </sis-sismap-sidepane-asset-list-item>
      </cdk-virtual-scroll-viewport>
    } @else {
      @if (isLoading) {
        <ion-row>
          <ion-col> Lade Assets... </ion-col>
        </ion-row>
      } @else {
        <ion-row>
          <ion-col> Keine Assets gefunden </ion-col>
        </ion-row>
      }
    }
  </div>
